var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvalidImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2973_9128)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6779 19.8434L14.4233 2.83691C14.0193 2.16694 13.2823 1.75073 12.5 1.75073C11.7176 1.75073 10.9806 2.16694 10.5766 2.83696L0.322043 19.8434C-0.0954863 20.5358 -0.10784 21.4034 0.289768 22.1075C0.687473 22.8116 1.43679 23.249 2.24538 23.249H22.7546C23.5632 23.249 24.3125 22.8116 24.7102 22.1075C25.1078 21.4033 25.0955 20.5357 24.6779 19.8434ZM23.2929 21.3071C23.1835 21.5009 22.9772 21.6214 22.7546 21.6214H2.24538C2.02278 21.6214 1.81648 21.501 1.70705 21.3072C1.59758 21.1133 1.601 20.8745 1.71589 20.6839L11.9705 3.67744C12.0818 3.49302 12.2846 3.37842 12.5 3.37842C12.7154 3.37842 12.9182 3.49302 13.0295 3.67744L23.284 20.6839C23.399 20.8745 23.4024 21.1133 23.2929 21.3071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5075 8.44751C11.8884 8.44751 11.4052 8.77974 11.4052 9.3687C11.4052 11.1657 11.6165 13.7479 11.6165 15.5449C11.6166 16.013 12.0243 16.2093 12.5075 16.2093C12.8699 16.2093 13.3834 16.013 13.3834 15.5449C13.3834 13.7479 13.5948 11.1657 13.5948 9.3687C13.5948 8.77979 13.0965 8.44751 12.5075 8.44751Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5227 17.2512C11.8583 17.2512 11.3599 17.7797 11.3599 18.414C11.3599 19.0332 11.8582 19.5768 12.5227 19.5768C13.1418 19.5768 13.6704 19.0332 13.6704 18.414C13.6704 17.7797 13.1417 17.2512 12.5227 17.2512Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2973_9128"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidImg);
export default __webpack_public_path__ + "static/media/invalidImg.d0379aa4872563df8a0c4c700b6069e7.svg";
export { ForwardRef as ReactComponent };